function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M0 6C0 6.4341 0.350749 6.78128 0.781034 6.78128H5.22087V11.2188C5.22087 11.653 5.57162 12 6.00177 12C6.43574 12 6.78281 11.6491 6.78281 11.2188V6.78128H11.219C11.6529 6.78128 12 6.43042 12 6C12 5.56984 11.6493 5.21898 11.219 5.21898H6.78268V0.78115C6.78268 0.347178 6.43193 0 6.00164 0C5.56781 0 5.22074 0.350729 5.22074 0.78115V5.2153H0.784584C0.350749 5.2153 0 5.5659 0 6Z",
  fill: "#5E5E5E"
});

function SvgPlusIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgPlusIcon;